// exports AlertManagementStatus - an immutable object 'enum'
// usage: import { AlertManagementStatus } from '../../enums/AlertManagementStatus';
const alertManagementStatus = {
    'Initialized': 10,
    'Error': 15,
    'Processing': 20,
    'Complete': 100
};
Object.freeze(alertManagementStatus);
export const AlertManagementStatus = alertManagementStatus;